import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { AsideComponent } from './aside/aside.component';
import { MenuComponent } from './menu/menu.component';
import { BaseComponent } from './base/base.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { ThemeRoutingModule } from './theme-routing.module';

@NgModule({
  declarations: [HeaderComponent, AsideComponent, MenuComponent, BaseComponent, FooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    ThemeRoutingModule
  ],
  exports: [
    HeaderComponent, AsideComponent, MenuComponent, BaseComponent, FooterComponent
  ]
})
export class ThemeModule { }
